import React from 'react';
import { QuestionCircleOutlined, ShoppingOutlined, DollarOutlined, EuroOutlined, HomeOutlined } from '@ant-design/icons';
import SwitchShop from '../shop/switch-shop';
import AppIconGroup from '../../components/app-icon-group';
import Withdraw from '../../components/withdraw';
import { safeCall } from "../../utils/jsbridge"; // 添加这一行
import { getCurrentShopId } from '../shop/get-current-shop';

const versionMap = {
    1: '基础版',
    2: '专业版',
    3: '连锁版'
}

const Index = () => {
    const [shopId, setShopId] = React.useState(null);
    const [summary, setSummary] = React.useState({});
    const {versionId, wdRate, cwdRate } = window.__baseInfo;
    // 获取店铺信息
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId) {
            loadShopSummary();
        }
    }, [shopId]);

    const loadShopSummary = async () => {
        getShopSummary(shopId).then(res => {
            setSummary(res.data);
        });
    }

    const getShopSummary = async (shopId) => {
        const res = await fetch(`/api/finance/fund-summary?shopId=${shopId}`);
        const result = await res.json();
        return result;
    }

    return (
        <div className="space-y-4">
            <SwitchShop />
            
            <AppIconGroup 
                items={[
                    {
                        id: 1,
                        href: '/finance/order-flow',
                        title: '支付流水',
                        icon: <ShoppingOutlined />,
                        color: 'from-blue-500 to-blue-600'
                    },
                    {
                        id: 2,
                        href: '/finance/funding-flow',
                        title: '资金流水',
                        icon: <DollarOutlined />,
                        color: 'from-green-500 to-green-600'
                    },
                    {
                        id: 3,
                        href: '/finance/funding-flow-invite',
                        title: '邀请资金流水',
                        icon: <EuroOutlined />,
                        color: 'from-purple-500 to-purple-600'
                    },
                    {
                        id: 4,
                        href: `/shop/create?shopId=${shopId}`,
                        title: '银行卡管理',
                        icon: <HomeOutlined />,
                        color: 'from-orange-500 to-orange-600'
                    }
                ]}
            />

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
                <div className="admin-card p-4">
                    <div className="text-sm text-text-secondary mb-1">余额</div>
                    <div className="text-xl font-semibold text-green-600">¥{(summary.totalAmount/100).toFixed(2)}</div>
                </div>

                <div className="admin-card p-4">
                    <div className="text-sm text-text-secondary mb-1">可提现</div>
                    <div className="text-xl font-semibold text-green-600">¥{((summary.withdrawAmount + summary.pendingAmount)/100).toFixed(2)}</div>
                </div>

                <div className="admin-card p-4">
                    <div className="text-sm text-text-secondary mb-1">待入账</div>
                    <div className="text-xl font-semibold text-green-600">¥{(summary.frozenAmount/100).toFixed(2)}</div>
                </div>

                <div className="admin-card p-4">
                    <div className="text-sm text-text-secondary mb-1">本月营收</div>
                    <div className="text-xl font-semibold text-green-600">¥{(summary.monthIncome/100).toFixed(2)}</div>
                </div>
            </div>
            
            {/* 使用新的Withdraw组件，包含了按钮和弹窗 */}
            <Withdraw
                maxAmount={summary.withdrawAmount/100}
                disabled={summary.withdrawAmount <= 0}
                type="order"
            />

            <div className="text-sm text-text-secondary">
                <QuestionCircleOutlined className="mr-1" /> 遇到问题请<a onClick={() => safeCall('16657132266')} className="text-primary hover:underline">联系客服</a>
            </div>
            
            <div className="admin-card p-4">
                <h3 className="admin-section-title mb-3">账户信息</h3>
                <div className="space-y-2 text-sm">
                    <div>版本：{versionMap[versionId]}</div>
                    <div>提现费率：{cwdRate * 100}% (<span className="line-through text-text-tertiary">{wdRate * 100}%</span>)</div>
                    <div>提现方式：{versionId === 1 ? '手动提现': '自动提现'}</div>
                </div>
            </div>
        </div>
    )
}

export default Index;